import type { ReactNode, Ref } from "react";
import Button, { type ButtonVariant } from "@/components/Button";
import { MaterialNames } from "../material_symbol_names";

interface Action {
  label: string;
  onClick: () => void;
  testId?: string;
  icon?: MaterialNames;
  variant?: ButtonVariant;
  disabled?: boolean;
}

interface Props {
  heading?: string;
  body?: ReactNode;
  actions?: Action[];
  headingRef?: Ref<HTMLHeadingElement>;
}

export default function SectionHeading({ heading, body, actions = [], headingRef }: Props) {
  const getButtonVariant = (index: number): "filled" | "outlined" | "text" => {
    if (index === 0) return "filled";
    if (index === 1) return "outlined";
    return "text";
  };

  return (
    <div className="flex flex-col sm:flex-row justify-between sm:items-center pt-12 pb-5">
      <div>
        {heading && (
          <h3 ref={headingRef} tabIndex={headingRef ? -1 : undefined} className="text-title-large-bold font-serif pb-1">
            {heading}
          </h3>
        )}
        {body && <p className="text-body-medium whitespace-pre-line">{body}</p>}
      </div>
      {actions.length > 0 && (
        <div className="flex flex-row sm:flex-row-reverse gap-2 mt-4 sm:mt-0">
          {actions.slice(0, 3).map((action, index) => (
            <Button
              key={action.label}
              type="button"
              variant={action.variant || getButtonVariant(index)}
              onClick={action.onClick}
              testId={action.testId}
              icon={action.icon}
              disabled={action.disabled}
            >
              {action.label}
            </Button>
          ))}
        </div>
      )}
    </div>
  );
}
